import get from 'lodash/get';
import superagent from '@ott/superagent';

import T from './types';

export const getHotTours = () => ({
  // eslint-disable-next-line consistent-return
  promise: async () => {
    const response = await superagent.get('/_mark/deals/tours').catch((error) => {
      return Promise.reject(error);
    });

    if (response.body) {
      return Promise.resolve(get(response, 'body.result', []));
    }
  },
  types: [T.GET_HOT_TOURS, T.GET_HOT_TOURS_SUCCESS, T.GET_HOT_TOURS_FAIL],
});
